<template>
    <div class="logindiv">
        <div class="logo">            
            <img alt="logo" src="@/assets/Logo MOPE slo.svg" height="80">
        </div>

	<div class="grid nested-grid">
		<div class="col-12">

			<div class="card fluid customheadercard">
				<div class="col-12 customheaderrow">
					<h5 class="stationsHeader">{{ translated('companyreg').toUpperCase() }}</h5>
				</div>												
			</div>		
			
			<div class="card fluid">       
				<div class="field grid">
					<div class="col-12">
						<div class="field grid headercompany">
							<h5 class="col-12">{{ translated('compdatatitle').toUpperCase() }}</h5>                   
						</div>                        
						<div class="field grid">
							<label for="name" class="col-4" :class="{'p-error': v$.CompanyName.$invalid && submitted}">{{ translated('companyname') }} *</label>
							<div class="col-8">
								<InputText type="text" v-model="CompanyName" @keypress="tipkam" />
							</div>                        
						</div>
						<div class="field grid">
							<label for="street" class="col-4" :class="{'p-error': v$.Street.$invalid && submitted}">{{ translated('street') }} *</label>
							<div class="col-8">
								<InputText type="text" v-model="Street" @keypress="tipkam" />
							</div>                        
						</div>
						<div class="field grid">
							<label for="street1" class="col-4"></label>
							<div class="col-8">
								<InputText type="text" v-model="Street1" @keypress="tipkam" />
							</div>                        
						</div>
						<div class="field grid">
							<label for="housenumber" class="col-4" :class="{'p-error': v$.HouseNumber.$invalid && submitted}">{{ translated('housenumber') }} *</label>
							<div class="col-8">
								<InputText type="text" v-model="HouseNumber" @keypress="tipkam" />
							</div>                        
						</div>

						<div class="field grid">
							<label class="col-4" :class="{'p-error': (v$.Zip.$invalid || v$.City.$invalid) && submitted }">{{ translated('zipcity') }} *</label>
							<div class="col-2">
								<InputText type="text" v-model="Zip" @keypress="tipkam" />
							</div>        
							<div class="col-6">
								<InputText type="text" v-model="City" @keypress="tipkam" />
							</div>                                               
						</div>                             
                        
                        <div class="field grid">
							<label for="housenumber" class="col-4" :class="{'p-error': v$.HouseNumber.$invalid && submitted}">{{ translated('country') }} *</label>
							<div class="col-8">

                                <Dropdown v-model="selectedCountry" :options="allCountries" filter optionLabel="name" class="w-full md:w-14rem combodrzave">
                                    <template #value="slotProps">
                                        <div v-if="slotProps.value" class="flex align-items-center">
                                            <div>{{ slotProps.value.name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ slotProps.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="slotProps">
                                        <div class="flex align-items-center">
                                            <div>{{ slotProps.option.name }}</div>
                                        </div>
                                    </template>
                                </Dropdown>

							</div>                        
						</div>		

                        
						<div class="field grid">
							<label for="housenumber" class="col-4" :class="{'p-error': v$.TaxId.$invalid && submitted}">{{ translated('taxid') }} *</label>
							<div class="col-8">
								<InputText type="text" v-model="TaxId" @keypress="tipkam" />
							</div>                        
						</div>       
						<div class="field grid">
							<label for="housenumber" class="col-4" :class="{'p-error': v$.RegisterId.$invalid && submitted}">{{ translated('registerid') }} *</label>
							<div class="col-8">
								<InputText type="text" v-model="RegisterId" @keypress="tipkam" />
							</div>                        
						</div>                                                       
						<div class="field grid">
							<label for="housenumber" class="col-4" :class="{'p-error': v$.WebSiteUrl.$invalid && submitted}">{{ translated('website') }} *</label>
							<div class="col-8">
								<InputText type="text" v-model="WebSiteUrl" @keypress="tipkam" />
							</div>                        
						</div>	      
						<div class="field grid">
							<label for="housenumber" class="col-4" :class="{'p-error': v$.InfoEmail.$invalid && submitted}">{{ translated('companyinfoemail') }} *</label>
							<div class="col-8">
								<InputText type="text" v-model="InfoEmail" @keypress="tipkam" />
							</div>                        
						</div>
						<div class="field grid">
							<label for="housenumber" class="col-4" :class="{'p-error': v$.InfoPhone.$invalid && submitted}">{{ translated('companyinfophone') }} *</label>
							<div class="col-8">
								<InputText type="text" v-model="InfoPhone" @keypress="tipkam" />
							</div>                        
						</div>      

                        <div class="field grid">
                            <label class="col-4" :class="{'p-error': v$.InfoPhone.$invalid && submitted}">{{ translated('companyinchargeperson') }} *</label>
                            <div class="col-8">
                                <InputText type="text" v-model="LegalRepresentative" :class="{'p-invalid':v$.InfoPhone.$invalid && submitted}" />
                            </div>                        
                        </div> 
                                          
                        
                        <div class="field grid">
                            <label class="col-12 idkodesection" :class="{'p-error': v$.InfoPhone.$invalid && submitted}">{{ translated('idcodelabel') }}</label>
                        </div> 
						
						<div class="field grid">
							<label for="evseid" class="col-4">{{ translated('cpotable') }}</label>
							<div class="col-1 checkboxfield">
								<Checkbox v-model="IsOperator" :binary="true" @change="tipkam"/>
							</div>    
                            <div class="col-7">                                
                                <InputText type="text" v-model="CPOCode" maxlength="10" :disabled="!IsOperator" :class="{'p-invalid':v$.CPOCode.$invalid && submitted}" />
                            </div>                                                  
						</div>
						<div class="field grid">
							<label for="evseid" class="col-4">{{ translated('msptable') }}</label>
							<div class="col-1 checkboxfield">
								<Checkbox v-model="IsServiceProvider" :binary="true" @change="tipkam" />
							</div>  
                            <div class="col-7">                                
                                <InputText type="text" v-model="MSPCode" maxlength="10" :disabled="!IsServiceProvider" :class="{'p-invalid':v$.MSPCode.$invalid && submitted}" />
                            </div>                                                    
						</div>     

                        <div class="field grid">
							<label for="evseid" class="col-4">{{ translated('rpotable') }}</label>
							<div class="col-1 checkboxfield">
								<Checkbox v-model="IsRPO" :binary="true" @change="tipkam"/>
							</div>  
                            <div class="col-7">                                
                                <InputText type="text" v-model="RPOCode" maxlength="10" :disabled="!IsRPO" :class="{'p-invalid':v$.RPOCode.$invalid && submitted}" />
                            </div>                                                    
						</div>
						<div class="field grid">
							<label for="evseid" class="col-4">{{ translated('rsptable') }}</label>
							<div class="col-1 checkboxfield">
								<Checkbox v-model="IsRSP" :binary="true" @change="tipkam" />
							</div>              
                            <div class="col-7">                                
                                <InputText type="text" v-model="RSPCode" maxlength="10" :disabled="!IsRSP" :class="{'p-invalid':v$.RSPCode.$invalid && submitted}" />
                            </div>                                        
						</div>  

                        <div class="field grid legendsection">
                            <label class="col-12 legendlabel" :class="{'p-error': v$.InfoPhone.$invalid && submitted}">{{ translated('codelegendtitle') }}</label>
                            <label class="col-12 legendcodeitem" :class="{'p-error': v$.InfoPhone.$invalid && submitted}">{{ translated('codecpolegend') }}</label>
                            <label class="col-12 legendcodeitem" :class="{'p-error': v$.InfoPhone.$invalid && submitted}">{{ translated('codemsplegend') }}</label>
                            <label class="col-12 legendcodeitem" :class="{'p-error': v$.InfoPhone.$invalid && submitted}">{{ translated('coderpolegend') }}</label>
                            <label class="col-12 legendcodeitem" :class="{'p-error': v$.InfoPhone.$invalid && submitted}">{{ translated('codersplegend') }}</label>
                        </div> 

                        <Divider type="dashed"/>

						<div class="field grid headeradmin">
							<h5 class="col-12">{{ translated('companyadmin').toUpperCase() }}</h5>                   
						</div> 

						<div class="field grid">
							<label class="col-4" :class="{'p-error': v$.NameSurname.$invalid && submitted}">{{ translated('namesurname') }}</label>
							<div class="col-8">
								<InputText type="text" v-model="NameSurname" @keypress="tipkam" />
							</div>                        
						</div>      
						<div class="field grid">
							<label class="col-4" :class="{'p-error': v$.Email.$invalid && submitted}">{{ translated('usernamemail') }}</label>
							<div class="col-8">
								<InputText type="text" v-model="Email" @keypress="tipkam" />
							</div>                        
						</div>      
						<div class="field grid">
							<label class="col-4" :class="{'p-error': v$.Password.$invalid && submitted}">{{ translated('password') }}</label>
							<div class="col-8">
                                <Password v-model="Password" toggleMask @keypress="tipkam"></Password>
							</div>                        
						</div>     
						<div class="field grid">
							<label class="col-4" :class="{'p-error': v$.RPassword.sameAsPassword.$invalid && submitted}">{{ translated('repeatpass') }}</label>
							<div class="col-8">
                                <Password v-model="RPassword" toggleMask @keypress="tipkam"></Password>
							</div>                        
						</div>   
                        
                        
						<div class="field grid headeradmin izjavatitle">
							<h5 class="col-12">{{ translated('registeragreetitle').toUpperCase() }}</h5>                   
						</div> 

						<div class="field grid">							
							<div class="col-1 checkboxfield">
								<Checkbox v-model="izjavaOpravljamo" :binary="true" />
							</div>              
                            <label for="evseid" class="col-11">{{ translated('registeragreefirst') }}</label>
						</div>  
                        <div class="field grid">							
							<div class="col-1 checkboxfield">
								<Checkbox v-model="izjavaBomoOpravljali" :binary="true" />
							</div>              
                            <label for="evseid" class="col-11">{{ translated('registeragreesecond') }}</label>
						</div>  

					</div>		
				</div>			
			</div>	

			<div v-if="Errors && !IsDirty" class="fluid">               
                <div v-for="napaka in Errors" class="field grid errorplaceholder" :key="napaka">
                    <span class="col-12">{{ napaka }}</span>
                </div>											
            </div>


			<div class="fluid">
				<div class="col-12 submitplaceholder">
					<Button class="submitbtn" :label="translated('register')" @click="handleSubmit(!v$.$invalid)" :disabled="!izjavljam"/>
				</div>												
			</div>         	

		</div>

 		

	</div>


    </div>  
</template>

<script>
// import "vue-select/dist/vue-select.css";

import { email, required, sameAs, between, numeric, minLength, maxLength, requiredUnless, requiredIf, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

import createHttp from "@/services/http";
import router from "@/router";
import { computed } from "vue"
import store from "@/store";

// import VueCountrySelect from '@/components/vue-country-select';
import countries from '@/components/countries.js'



const davcna = (value) => (value.match(/^[A-Z]{2}[0-9]{8}$/) == value);
const mspcpoid = (value) => (value.match(/^[A-Z]{2}[\*|-][A-Z0-9]{3}$/) == value);

export default {
    // components: { Dropdown },    
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            CompanyName: '',
            Street: '',
            Street1: '',
            HouseNumber: '',
            Zip: '',
            City: '',
            TaxId: '',
            RegisterId: '',
            WebSiteUrl: '',
            InfoEmail: '',
            InfoPhone: '',
            LegalRepresentative: '',
            IsOperator: false,
            IsServiceProvider: false,
            IsRPO: false,
            IsRSP: false,
            MSPCode: '',
            CPOCode: '',
            RSPCode: '',
            RPOCode: '',
            Email: '',
            Password: '',
            RPassword: '',
            NameSurname: '',
            Errors: [],
            IsDirty: true,
            translated: computed(() => store.getters.getTranslate),
            submitted: false,
            selectedCountry: null, // Nastavim, da je default Slovenija,
            allCountries: null,
            izjavaOpravljamo: false,
            izjavaBomoOpravljali: false,
            izjavljam: computed(() => this.izjavaOpravljamo || this.izjavaBomoOpravljali)
        }
    },
    validations() {              
        let myvalidations = {
            CompanyName: { required },
            Street: { required },
            HouseNumber: { required },
            // Zip: { required, between: between(1000, 9999) },
            Zip: { required, between: between(1000, 999999) },
            City: { required },
            // TaxId: { required, davcna },
            TaxId: { required },
            // RegisterId: { numeric, minLength: minLength(7), maxLength: maxLength(10), required },
            RegisterId: { numeric, minLength: minLength(7), maxLength: maxLength(15), required },
            WebSiteUrl: { required },
            InfoEmail: { required, email },
            InfoPhone: { required },
            LegalRepresentative: { required },
            NameSurname: { required },
            Email: { required, email },
            Password: { required, minLength: minLength(6) },
            RPassword: { sameAsPassword: sameAs(this.Password) },

            CPOCode: { 
                required: requiredIf(() => this.IsOperator),
                mspcpoid: value => !this.IsOperator || mspcpoid(value)
            },           
            MSPCode: { 
                required: requiredIf(() => this.IsServiceProvider),
                mspcpoid: value => !this.IsServiceProvider || mspcpoid(value)
            }, 
            RPOCode: { 
                required: requiredIf(() => this.IsRPO),
                mspcpoid: value => !this.IsRPO || mspcpoid(value)
            },           
            RSPCode: { 
                required: requiredIf(() => this.IsRSP),
                mspcpoid: value => !this.IsRSP || mspcpoid(value)
            }  
        };

        return myvalidations;
    },    
    methods: {
        tipkam() {
            this.IsDirty = true;
        },
        async handleSubmit(isFormValid) {

            // debugger;
            // let tmpTest = this.selectedCountry;
            // let testNovi = '';
            // debugger;
            // return;
            // console.log('a je enako: ');
            // console.log(this.v$.Password.$invalid);
            // console.log(this.v$.RPassword);
            // console.log('ni enako');

            this.submitted = true;
            if (!isFormValid) {
                return;
            }

            this.Errors = [];
            this.IsDirty = false;
            console.log('klicem submit')

            let CompanyRegister = {
                CompanyName: this.CompanyName,
                Street: this.Street,
                Street1: this.Street1,
                HouseNumber: this.HouseNumber,
                Zip: this.Zip,
                City: this.City,
                TaxId: this.TaxId,
                RegisterId: this.RegisterId,
                WebSiteUrl: this.WebSiteUrl,
                InfoEmail: this.InfoEmail,
                InfoPhone: this.InfoPhone,
                IsOperator: this.IsOperator,
                IsServiceProvider: this.IsServiceProvider,
                Email: this.Email,
                Password: this.Password,
                NameSurname: this.NameSurname,
                CountryCode: this.selectedCountry.code, //'SI'

                // ToDo: Dodati moram atribute za RSP, RPO, isRSP, isRPO ter kontaktno osebo (zakoniti zastopnik)
                IsRPO: this.IsRPO,
                IsRSP: this.IsRSP,

                RPOCode: this.IsRPO ? this.RPOCode : '',
                RSPCode: this.IsRSP ? this.RSPCode : '',
                MSPCode: this.IsServiceProvider ? this.MSPCode : '',
                CPOCode: this.IsOperator ? this.CPOCode : '',
                
                LegalRepresentative: this.LegalRepresentative,

                IzjavaOpravljamo: this.izjavaOpravljamo,
                IzjavaBomoOpravljali: this.izjavaBomoOpravljali
            }


            const http = createHttp(false); 
            console.log(CompanyRegister);
            try {

                http.post(process.env.VUE_APP_AUTH_FOLDER + "/Register?languageCode=EN", CompanyRegister)
                    .then((response) => { 
                        //console.log('OK response');
                        //console.log(response);
                        router.push("login");
                    })
                    .catch((error) => {
                        const myErr = {...error};

                        //console.log('ERROR');
                        console.log(myErr) 
                        this.Errors = myErr.response.data.Errors;
                        
                        
                })

/*
                const response = await http.post("https://localhost:44378/AuthManagement/Register?languageCode=SI", CompanyRegister);
                console.log('response na insert')
                console.log(response)

                if(response.status==200) {
                    console.log('VSE JE OK!!!')
                    router.push("/");
                    
                } else {
                    console.log('ERROR!!!')
                }

                console.log(response)
                */
            } catch (error) {
                //console.log('ERROR TRY CATCHE!');
                console.log(http);
                //console.log(error);
            }
            
        }
    },
    async created() {
        // debugger;
        this.allCountries = countries;
        this.selectedCountry = this.allCountries.find(country => country.code == 'SI');
        // debugger;        
    }
}
</script>


<style scoped>
    .errorplaceholder span {
        color:red;
    }

    .errorplaceholder {
        text-align: center;
    }

    .card.fluid.customheadercard {
        height: 60px;
    }

    .headercompany, .headeradmin {
        background: linear-gradient(91deg, #044868, #f8f9fa);
        height: 25px;
        color: white;
    }

    .submitplaceholder {
        text-align: center;
    }
    .submitbtn {
        width:120px;
    }
    form {
        background: white;
        padding: 20px;
        border-radius: 0 0 10px 10px;
    }

    .passdiv {
        margin-top:30px;
    }

    form button {
        display: block;
        margin: 60px auto 0;
    }

    .logindiv {
        max-width: 600px;
        margin: 0 auto;
    }

    .errordiv {
        height: 10px;
        padding-top: 40px;
        text-align: center;
    }

    .logindiv .logo {
        /* background: black; */
        padding:10px;
        border-left: solid 2px white;
        border-right: solid 2px white;
        border-top: solid 2px white;
        border-radius: 10px 10px 0 0;
    }

    .col-12.customheaderrow {
        padding-left: 0px;
    }

    h5.stationsHeader {
        font-weight: bolder;
    }

    .combodrzave {
        width: 100% !important;
    }

    .checkboxfield {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    input:disabled {
        background-color: #ebebeb;
    }



    label.idkodesection {font-weight: bold;margin-top: 30px;}
    label.legendlabel {font-weight: bold;margin-top: 20px;margin-bottom: 10px;}
    .izjavatitle {margin-top: 50px;}

</style>